import { render, staticRenderFns } from "./sign_up.vue?vue&type=template&id=58b45b1e&"
import script from "./sign_up.vue?vue&type=script&lang=js&"
export * from "./sign_up.vue?vue&type=script&lang=js&"
import style0 from "./sign_up.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports